function reduceTracks(res) {
  return {
    data: res?.data?.map((track) => {
      const keys = Object.keys(track)
      const reduced = {}
      keys.forEach((key) => (reduced[key] = track[key] || ''))
      return reduced
    }),
    limit: res?.limit,
    page: res?.page,
    total: res?.total,
  }
}

export default reduceTracks
